// GlucoseCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Rata-rata Glukosa Perkiraan";
const DESCRIPTION =
  "Kalkulator rata-rata glukosa perkiraan (eAG): hitung kadar gula darah selama 3 bulan berdasarkan analisis hemoglobin terglikasi (HbA1c)! Alat yang disetujui secara medis untuk penderita diabetes dengan interpretasi hasil dan perbandingan dengan tingkat yang direkomendasikan.";
const KEYWORDS = "kalkulator, rata-rata glukosa, HbA1c, gula darah";
const OG_URL =
  "https://do-calculate.com/calculator/id/estimated-average-glucose-calculator/";
const diabetesRanges = {
  diabetes: {
    HbA1c: [
      {
        limit: 6,
        message: "âœ… Tingkat HbA1c Anda di bawah target diabetes - kerja bagus!",
        bg: "alert alert-success",
      },
      { limit: 7, message: "âœ… Rasio HbA1c baik", bg: "alert alert-success" },
      {
        limit: 7.5,
        message: "â—Rasio HbA1c secara umum sangat tinggi.",
        bg: "alert alert-danger",
      },
      {
        limit: 8,
        message: "â—Rasio HbA1c secara umum sangat tinggi.",
        bg: "alert alert-danger",
      },
      {
        limit: Infinity,
        message: "â—Rasio HbA1c secara umum sangat tinggi.",
        bg: "alert alert-danger",
      },
    ],
    eAG: [
      {
        limit: 140,
        message: "Rata-rata glukosa perkiraan dalam kisaran normal.",
        bg: "alert alert-success",
      },
      {
        limit: 154.2,
        message: "Rata-rata glukosa perkiraan baik.",
        bg: "alert alert-success",
      },
      {
        limit: Infinity,
        message: "Tingkat glukosa tinggi.",
        bg: "alert alert-danger",
      },
    ],
  },
  nonDiabetes: {
    HbA1c: [
      {
        limit: 6,
        message: "ðŸ’š HbA1c Anda dalam kisaran normal.",
        bg: "alert alert-success",
      },
      {
        limit: 6.5,
        message:
          "ðŸ”¶ Tingkat HbA1c dalam tahap pradiabetes. Hubungi dokter, makan dengan baik, dan lakukan olahraga.",
        bg: "alert alert-warning",
      },
      {
        limit: Infinity,
        message: "ðŸ”º Hasil Anda menunjukkan diabetes. Konsultasikan dengan dokter Anda.",
        bg: "alert alert-danger",
      },
    ],
    eAG: [
      {
        limit: 116,
        message: "Tingkat glukosa normal.",
        bg: "alert alert-success",
      },
      {
        limit: Infinity,
        message: "Tingkat glukosa menunjukkan diabetes! Hubungi dokter.",
        bg: "alert alert-danger",
      },
    ],
  },
};
function EstimatedAverageGlucoseCalculator() {
  const [hbA1c, setHbA1c] = useState("");
  const [avgGlucose, setAvgGlucose] = useState("");
  const [diabetesStatus, setDiabetesStatus] = useState("no");
  const [feedback, setFeedback] = useState("");
  const handleHbA1cChange = (e) => {
    setHbA1c(e.target.value);
    setAvgGlucose("");
  };
  const handleAvgGlucoseChange = (e) => {
    setAvgGlucose(e.target.value);
    setHbA1c("");
  };
  const calculateResults = () => {
    if (hbA1c) {
      const hbA1cValue = parseFloat(hbA1c);
      const calculatedEAG = 28.7 * hbA1cValue - 46.7;
      setAvgGlucose(calculatedEAG.toFixed(2));
      provideFeedback(hbA1cValue, "HbA1c");
    } else if (avgGlucose) {
      const avgGlucoseValue = parseFloat(avgGlucose);
      const calculatedHbA1c = (avgGlucoseValue + 46.7) / 28.7;
      setHbA1c(calculatedHbA1c.toFixed(2));
      provideFeedback(avgGlucoseValue, "eAG");
    }
  };
  const provideFeedback = (value, type) => {
    let rangeType = diabetesStatus === "yes" ? "diabetes" : "nonDiabetes";
    let feedbackMessages = diabetesRanges[rangeType][type];
    for (let i = 0; i < feedbackMessages.length; i++) {
      if (value < feedbackMessages[i].limit) {
        setFeedback(feedbackMessages[i]);
        break;
      }
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Rata-rata glukosa perkiraan (eAG) dan apa artinya? Rata-rata glukosa perkiraan (Estimated Average Glucose) adalah ukuran yang digunakan untuk memperkirakan tingkat glukosa rata-rata dalam darah selama periode yang panjang. Ini dihitung menggunakan persentase HbA1c (hemoglobin A1c), yang merupakan indikator yang mencerminkan tingkat glukosa rata-rata dalam darah selama 2-3 bulan.
                </p>
                <p>
                  Bagaimana cara menghitung rata-rata glukosa perkiraan? Kami menggunakan persamaan berikut untuk menghitung rata-rata glukosa perkiraan:{" "}
                  <p>Rata-rata Glukosa Perkiraan = (28,7 Ã— HbA1c) - 46,7</p>
                  Di mana:
                </p>
                <ul>
                  <li>
                    HbA1c adalah persentase yang mencerminkan tingkat glukosa rata-rata dalam darah selama bulan-bulan sebelumnya.
                  </li>
                  <li>
                    Nilai 28,7 mewakili konversi dari satuan HbA1c ke rata-rata glukosa dalam satuan miligram/desiliter (mg/dL).
                  </li>
                  <li>
                    Nilai 46,7 mengkompensasi konversi antara satuan dan mencerminkan nilai yang diharapkan dari rata-rata glukosa darah pada HbA1c = 0%.
                  </li>
                </ul>
                <p>Mengapa rata-rata glukosa perkiraan penting?</p>
                <p>
                  Rata-rata glukosa perkiraan membantu dalam memperkirakan seberapa baik seseorang mengendalikan tingkat glukosa darah mereka dalam jangka panjang. Ini adalah indikator penting untuk manajemen diabetes, karena penderita diabetes atau mereka yang memiliki masalah dalam mengatur tingkat glukosa dapat menggunakannya untuk mengevaluasi efektivitas pengobatan dan membuat keputusan yang tepat.{" "}
                </p>
                <p>
                  Kalkulator dikembangkan berdasarkan{" "}
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2742903/"
                    rel="nofollow"
                  >
                    Studi Rata-rata Glukosa Berasal dari A1c Terjemahan Tes A1C ke Nilai Glukosa Rata-rata yang Diperkirakan; Perawatan Diabetes; Juni 2008
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <p>
                    Harap isi hanya satu dari kolom berikut: persentase HbA1c atau rata-rata glukosa
                  </p>
                </div>
                <div >
                  <div>
                    <hr />
                                        <div className="form-group">
                      <label htmlFor="status" className="form-label ms-2">
                        Apakah Anda menderita diabetes?
                      </label>
                      <select
                        id="status"
                        value={diabetesStatus}
                        onChange={(e) => setDiabetesStatus(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="no">Tidak</option>
                        <option value="yes">Ya</option>
                      </select>
                    </div>
                    <hr />
                                        <div className="form-group">
                      <label htmlFor="hbA1c">Masukkan persentase HbA1c:</label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="hbA1c"
                          type="number"
                          value={hbA1c}
                          onChange={handleHbA1cChange}
                          className="form-control"
                        />
                        <span className="input-group-text ">%</span>
                      </div>
                    </div>
                    <hr />
                                        <div className="form-group">
                      <label htmlFor="avgGlucose">Masukkan rata-rata glukosa:</label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="avgGlucose"
                          type="number"
                          value={avgGlucose}
                          onChange={handleAvgGlucoseChange}
                          className="form-control"
                        />
                        <span className="input-group-text ">(mg/dL)</span>
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={calculateResults}
                    >
                      Hitung
                    </button>
                    <hr />
                                        { feedback && (
                      <div
                        className={`p-3 mb-2 ${feedback.bg}`}
                        style={
                          feedback.bg === "alert alert-danger"
                            ? { backgroundColor: "#DC3545" }
                            : {}
                        }
                      >
                        <h4>Hasil:</h4>
                        <p>{feedback.message}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Tabel Konversi antara HbA1c dan Rata-rata Glukosa
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Tabel Konversi</h2>
                  </u>
                  <p>
                    Tabel ini memungkinkan Anda mengkonversi HbA1c ke rata-rata glukosa tanpa perlu perhitungan.
                  </p>
                  <table className="bmi-table" style={{ overflowX: "auto" }}>
                    <thead>
                      <tr>
                        <th >HbA1c</th>
                        <th ></th>
                        <th >eAG</th>
                        <th ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>%</td>
                        <td>mmol/mol</td>
                        <td>mmol/L</td>
                        <td>mg/dl</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>31</td>
                        <td>(4.2â€“6.7) 5.4</td>
                        <td>97 (76â€“120)</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>42</td>
                        <td>(5.5â€“8.5) 7.0</td>
                        <td>126 (100â€“152)</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>53</td>
                        <td>(6.8â€“10.3) 8.6</td>
                        <td>154 (123â€“185)</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>64</td>
                        <td>(8.1â€“12.1) 10.2</td>
                        <td>183 (147â€“217)</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>75</td>
                        <td>(9.4â€“13.9) 11.8</td>
                        <td>212 (170â€“249)</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>86</td>
                        <td>(10.7â€“15.7) 13.4</td>
                        <td>240 (193â€“282)</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>97</td>
                        <td>(12.0â€“17.5) 14.9</td>
                        <td>269 (217â€“314)</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>108</td>
                        <td>(13.3â€“19.3) 16.5</td>
                        <td>298 (240â€“347)</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>119</td>
                        <td>(15â€“21) 18.1</td>
                        <td>326 (260â€“380)</td>
                      </tr>
                      <tr>
                        <td>14</td>
                        <td>130</td>
                        <td>(16â€“23) 19.7</td>
                        <td>355 (290â€“410)</td>
                      </tr>
                      <tr>
                        <td>15</td>
                        <td>140</td>
                        <td>(17.5â€“25) 21.3</td>
                        <td>384 (310â€“440)</td>
                      </tr>
                      <tr>
                        <td>16</td>
                        <td>151</td>
                        <td>(19â€“26) 22.9</td>
                        <td>413 (330â€“480)</td>
                      </tr>
                      <tr>
                        <td>17</td>
                        <td>162</td>
                        <td>(20â€“28) 24.5</td>
                        <td>441 (460â€“510)</td>
                      </tr>
                      <tr>
                        <td>18</td>
                        <td>173</td>
                        <td>(21â€“30) 26.1</td>
                        <td>470 (380â€“540)</td>
                      </tr>
                      <tr>
                        <td>19</td>
                        <td>184</td>
                        <td>(23â€“32) 27.7</td>
                        <td>499 (410â€“570)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default EstimatedAverageGlucoseCalculator;
